import React from "react";
import Header from "../landing/components/Header";
import { Link } from "react-router-dom";
import shadow2phone from "../landing/assets/images/2phone_shadow.png";
import gradLeft from "../landing/assets/images/grad_left.png";
import gradRight from "../landing/assets/images/grad_right.png";
import img1 from "../landing/assets/images/sect-imgs/1.png";
import img2 from "../landing/assets/images/sect-imgs/2.png";
import img3 from "../landing/assets/images/sect-imgs/3.png";
import img4 from "../landing/assets/images/sect-imgs/4.png";
import img5 from "../landing/assets/images/sect-imgs/5.png";
import img6 from "../landing/assets/images/sect-imgs/6.png";
import Footer from "../landing/components/Footer";
import phoneImg from '../landing/assets/images/2phone.png';
import shadowImg from '../landing/assets/images/btn_shadow.png';
import { Helmet } from 'react-helmet';



export default function Homepage() {
  return (
    <>
      <Helmet>
        <link rel="stylesheet" href="../landing/assets/css/index.css" />
      </Helmet>
      <Header />
      <body className="homepage-area">
        <section className="section f-sec pd:mt-16 pt-12">
          <div className="container">
            <img className="phone2" style={{ backgroundImage: `url(${phoneImg})` }} src={shadow2phone} alt="" />
            <h1 className="section_title mb-4 max-w-[710px] text-2xl font-bold md:mb-8 md:text-6xl">
              <span className="faded_txt">Зарабатывай</span> на своем дейтинг
              трафике вместе с нами
            </h1>
            <div className="faded_txt mb-4 w-full max-w-[740px] md:mb-8">
              Партнерская программа в сфере знакомств
            </div>
            <div className="flex items-center gap-6">
              <Link className="btn_grad_bc" to="https://fl-dating.su/login">
                Авторизоваться
              </Link>
              <Link
                to={"https://fl-dating.su/register"}
                className="pink_btn gradient-border"
                style={{ backgroundImage: `url(${shadowImg})` }}
              >
                <span className="faded_txt">Регистрация</span>
              </Link>
            </div>
          </div>
        </section>
        <section className="section relative my-12 md:my-20">
          <img src={gradLeft} className="grad_left" alt="" />
          <div className="container mx-auto max-w-[740px]">
            <h2 className="mx-auto mb-4 max-w-[630px] text-center text-xl font-bold md:text-4xl">
              Почему вы должны присоединиться к нам?
            </h2>
            <div className="text-center leading-[110%] text-white">
              Помогаем с запуском рекламных кампаний, подбираем релевантные
              промо-материалы. Поможем оптимизировать трафик и увеличить
              прибыль.
            </div>
          </div>
        </section>
        <section className="section relative">
        <img src={gradRight} className="grad_right top-[25%]" alt="" />
        <img src={gradLeft} className="grad_left top-[50%]" alt="" />

          <div className="container-sm container flex flex-col gap-6 md:gap-24 punkts">
            <div className="flex flex-col items-center justify-between gap-6 md:flex-row md:items-end xl:gap-20">
              <img src={img1} alt="" />
              <div className="punkt_info">
                <h5 className="mb-1 text-lg leading-[120%] font-bold text-[#FF4060] md:text-2xl">
                  Пункт 1
                </h5>
                <h3 className="mb-3.5 text-xl font-extrabold md:text-3xl">
                  Имеем собственные уникальные офферы в Telegram
                </h3>
                <p className="mb-6 leading-[150%]">
                  У нас есть эксклюзивные и уникальные офферы в Telegram,
                  которые недоступны в других партнерских сетях. Это позволяет
                  вам получать высокий доход за счет эксклюзивности предложений.
                </p>
                <Link
                  to={"https://fl-dating.su/register"}
                  className="pink_btn gradient-border w-shadow"
style={{ backgroundImage: `url(${shadowImg})` }}
                >
                  <span className="faded_txt">Регистрация</span>
                </Link>
              </div>
            </div>
            <div className="flex flex-col items-center justify-between gap-6 md:flex-row-reverse md:items-end xl:gap-20">
              <img src={img2} alt="" />
              <div className="punkt_info">
                <h5 className="mb-1 text-lg leading-[120%] font-bold text-[#FF4060] md:text-2xl">
                  Пункт 2
                </h5>
                <h3 className="mb-3.5 text-xl font-extrabold md:text-3xl">
                  Возможность работать по различным моделям
                </h3>
                <p className="mb-6 leading-[150%]">
                  Мы предоставляем гибкие условия сотрудничества с возможностью
                  работы по разным моделям: RevShare, оплате за регистрацию или
                  за покупку. Выбирайте наиболее выгодный формат для вашего
                  трафика.
                </p>
                <Link
                  to={"https://fl-dating.su/register"}
                  className="pink_btn gradient-border w-shadow"
style={{ backgroundImage: `url(${shadowImg})` }}
                >
                  <span className="faded_txt">Регистрация</span>
                </Link>
              </div>
            </div>
            <div className="flex flex-col items-center justify-between gap-6 md:flex-row md:items-end xl:gap-20">
              <img src={img3} alt="" />
              <div className="punkt_info">
                <h5 className="mb-1 text-lg leading-[120%] font-bold text-[#FF4060] md:text-2xl">
                  Пункт 3
                </h5>
                <h3 className="mb-3.5 text-xl font-extrabold md:text-3xl">
                Топ-1 конверсия среди партнерок знакомств
                </h3>
                <p className="mb-6 leading-[150%]">
                Наша партнерская программа по знакомствам обеспечивает топ-1 конверсию на рынке. Вы получаете максимальную отдачу от каждого привлеченного пользователя.
                </p>
                <Link
                  to={"https://fl-dating.su/register"}
                  className="pink_btn gradient-border w-shadow"
style={{ backgroundImage: `url(${shadowImg})` }}
                >
                  <span className="faded_txt">Регистрация</span>
                </Link>
              </div>
            </div>
            <div className="flex flex-col items-center justify-between gap-6 md:flex-row-reverse md:items-end xl:gap-20">
              <img src={img4} alt="" />
              <div className="punkt_info">
                <h5 className="mb-1 text-lg leading-[120%] font-bold text-[#FF4060] md:text-2xl">
                  Пункт 4
                </h5>
                <h3 className="mb-3.5 text-xl font-extrabold md:text-3xl">
                Выплаты без задержек от 2000 RUB
                </h3>
                <p className="mb-6 leading-[150%]">
                Мы гарантируем быстрые и своевременные выплаты от 2000 RUB без задержек. Ваши заработанные средства всегда доступны в срок.
                </p>
                <Link
                  to={"https://fl-dating.su/register"}
                  className="pink_btn gradient-border w-shadow"
style={{ backgroundImage: `url(${shadowImg})` }}
                >
                  <span className="faded_txt">Регистрация</span>
                </Link>
              </div>
            </div>
            <div className="flex flex-col items-center justify-between gap-6 md:flex-row md:items-end xl:gap-20">
              <img src={img5} alt="" />
              <div className="punkt_info">
                <h5 className="mb-1 text-lg leading-[120%] font-bold text-[#FF4060] md:text-2xl">
                  Пункт 5
                </h5>
                <h3 className="mb-3.5 text-xl font-extrabold md:text-3xl">
                Постоянные бонусы, конкурсы
                </h3>
                <p className="mb-6 leading-[150%]">
                Регулярно проводим бонусные акции, конкурсы и розыгрыши среди партнеров. У вас есть шанс дополнительно увеличить свой доход.
                </p>
                <Link
                  to={"https://fl-dating.su/register"}
                  className="pink_btn gradient-border w-shadow"
style={{ backgroundImage: `url(${shadowImg})` }}
                >
                  <span className="faded_txt">Регистрация</span>
                </Link>
              </div>
            </div>
            <div className="flex flex-col items-center justify-between gap-6 md:flex-row-reverse md:items-end xl:gap-20">
              <img src={img6} alt="" />
              <div className="punkt_info">
                <h5 className="mb-1 text-lg leading-[120%] font-bold text-[#FF4060] md:text-2xl">
                  Пункт 6
                </h5>
                <h3 className="mb-3.5 text-xl font-extrabold md:text-3xl">
                Реферальная программа - 10%
                </h3>
                <p className="mb-6 leading-[150%]">
                Наша реферальная программа позволяет получать 10% от дохода привлеченных вами партнеров. Зарабатывайте больше, приглашая коллег в нашу систему.
                </p>
                <Link
                  to={"https://fl-dating.su/register"}
                  className="pink_btn gradient-border w-shadow"
style={{ backgroundImage: `url(${shadowImg})` }}
                >
                  <span className="faded_txt">Регистрация</span>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </body>
      <Footer />
    </>
  );
}
